import React, { Component } from 'react';
import VideoPopup from './VideoPopup';
import ImageGallery from './ImageGallery';

class ImageHandler extends Component {
  checkForVideo = url => {
    if (url.search('vimeo') !== -1 || url.search('youtube') !== -1) {
      let videoData = url.split('_');
      if (videoData.length > 1) {
        let src = 'https://player.vimeo.com/video/' + videoData[1];
        if (videoData[0] === 'youtube')
          src = 'https://www.youtube.com/embed/' + videoData[1];
        return src;
      }
    }
    return false;
  };
  cleanImages = images => {
    return images.filter(image => {
      return !this.checkForVideo(image.alt);
    });
  };
  getActiveIndex = (images, activeImage) => {
    for (let i = 0; i < images.length; i++) {
      if (images[i].url === activeImage.url) return i;
    }
  };
  render() {
    const { images, activeImage, setActiveImage } = this.props;
    const videoSrc = this.checkForVideo(activeImage.alt);

    //SHOW VIDEO POPUP IF SELECTED IMAGE IS VIDEO
    if (videoSrc) {
      return <VideoPopup videoSrc={videoSrc} setActiveImage={setActiveImage} />;
    }
    //ELSE SHOW IMAGE GALLERY
    else {
      //REMOVE VIDEO IMAGES FROM ARRAY
      const images_novideo = this.cleanImages(images);
      const activeSliderImage = this.getActiveIndex(
        images_novideo,
        activeImage
      );
      return (
        <ImageGallery
          images={images_novideo}
          setActiveImage={setActiveImage}
          activeSliderImage={activeSliderImage}
        />
      );
    }
  }
}

export default ImageHandler;
